// extracted by mini-css-extract-plugin
module.exports = {"refundText":"RefundPolicyPage_refundText__2EMcO"};